import { createWithEqualityFn as create } from 'zustand/traditional';

interface UseAuctionsStore {
    showGettingStarted: boolean;
    setShowGettingStarted: (value: boolean) => void;
}

const useAuctionsStore = create<UseAuctionsStore>((set, get) => ({
    showGettingStarted: true,
    setShowGettingStarted: showGettingStarted => set({ showGettingStarted }),
}));

export { useAuctionsStore };
